import { render, staticRenderFns } from "./ImpactEntryToRequirement.vue?vue&type=template&id=4cc41444&"
import script from "./ImpactEntryToRequirement.vue?vue&type=script&lang=ts&"
export * from "./ImpactEntryToRequirement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports